import React, {useEffect, useState} from 'react';
import { useParams } from 'react-router-dom';
import {getHeaderNotification, getFaqsData, getParkhelpData} from '../../utils/endpoints'
import InnerContent from '../components/innerContent';
import { Container } from 'react-bootstrap';
import Loading from '../components/loading';
import HeaderNotification from '../components/headerNotification';
import Faqs from '../components/faq';
import Header from '../components/header';
import Footer from '../components/footer';
import Breadcrumb from '../components/breadcrumb';
import { Helmet } from 'react-helmet';

const StatueHelpDetail = (props) => {
    const [headerNotificationData, setheaderNotificationData] = useState(null);
    const [faqs, setFaqs] = useState(null);
    const [helpData, setHelpData] = useState(null);
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchData = async () => {
          try {
            const helpData = await getParkhelpData(id);
            setHelpData(helpData);
            const headerNotificationData = await getHeaderNotification();
            setheaderNotificationData(headerNotificationData);
            const faqs = await getFaqsData();
            setFaqs(faqs);
            setIsLoading(false);
          } catch (error) {
            setError(error);
            setIsLoading(false);
          }
        };
      
        fetchData();
      }, [id]);

      const faQSlice = faqs;
      

      if (isLoading) {
        return <div><Loading /></div>;
      }
    
      if (error) {
    return (
    <div className='error_modal'>
      <div className='error_modal-wrapper'>
        <img  src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="Statue of Belief"/>
        <h1>We’re making a few improvements to serve you better. Please check back shortly for an enhanced experience.</h1>
        <button class="reload-btn" onClick={() => window.location.reload()}>
            Reload Page
        </button>
      </div>
    </div>
    );
  }

  return (
    <div>
      <Helmet>
      <title>{helpData[0]?.title?.rendered} || Statue of Belief || Worlds tallest shiva Statue</title>
      </Helmet>
        <HeaderNotification compData={headerNotificationData}/>
        <Header />
        <Container className='pt-5 mt-5'>
        <Breadcrumb pageTitle={helpData[0]?.title?.rendered}/>
        <h1 className="blog-heading mt-3" dangerouslySetInnerHTML={{ __html: helpData[0]?.title?.rendered }}></h1>
        <InnerContent compData={helpData}/>
        {/* <div className='visitor-wrapper'>
          <div className='visitor-thumb'>
            <img src="http://www.statueofbelief.in/content/wp-content/uploads/2023/06/visitor-banner.webp"/>
          </div>
          <div className='visitor-pointers'>
              <div className='pointers pointer-parking'>
                <span>Parking<b>पार्किंग</b></span>
              </div>
              <div className='pointers pointer-goKarting'>
                <span>Go Karting<b></b></span>
              </div>
              <div className='pointers pointer-snowWorld'>
                <span>Snow World<b>स्नो वर्ल्ड</b></span>
              </div>
              <div className='pointers pointer-marriageGarden'>
                <span>Marriage Garden<b>मैरिज गार्डन</b></span>
              </div>
          </div>
        </div> */}
      </Container>
      <Faqs compData={faQSlice.slice(0,5)} />
      <Container>
        {faqs.length > 5 ? <div className='faq_viewMore'><a href="/faqs">View more</a></div> : ''}
        </Container>
      <Footer />
    </div>
  );
};

export default StatueHelpDetail;